import React, { useContext, useState } from 'react';
import STC from '../../../../STCLibrary/STCFactory/STCFactory';
import { LoginAPIs } from '../../../../API/LoginAPIs/LoginAPIs';
import ApiResponseHandler from '../../../../STCLibrary/ApiResponseHandler/ApiResponseHandler';
import NotificationContext from '../../../../STCLibrary/NotificationSystem/NotificationContext';
import { useNavigate } from 'react-router-dom';


export default function ForgotPasswordForm({setForgotPassword}){

    const notificationCtx = useContext(NotificationContext);
    const navigate = useNavigate();

    const [sending, setSending] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [email, setEmail] = useState('');



    const handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setSending(true);
        LoginAPIs.PostForgotPassword({email: email})
        .then((response) => {
            if(response.status === 200 && !response.data.error){
                setShowSuccess(true);
                ApiResponseHandler(response, notificationCtx, navigate);
                setSending(false);
            }
            else{
                setShowError(true);
                setSending(false);
            }
        })
        .catch((err) => {
            setShowError(true);
            setSending(false);
            ApiResponseHandler(err.response, notificationCtx, navigate)
        })


    }

    return(
        <div>

            {showSuccess ? 
                <div>
                    <div className='mt-2'>
                        <STC.Alert variant='success'>
                            Successfully requested a password reset! Please check the inbox of <strong>{email}</strong> to find your reset password link.
                        </STC.Alert>
                    </div>
                    <div className="mt-2 text-center">
                        <span
                            style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                            onClick={()=> setForgotPassword(false)}
                        >
                            Return to Login
                        </span>
                    </div>
                </div>
                :
                <div>

                    <div className='m-2' style={{textAlign: 'center'}}>Please enter your email address below to request a password reset.</div>
                    <STC.Form onSubmit={handleSubmit}>

                        <STC.Form.FloatingLabel className="mb-3">
                            <STC.Form.Control
                                id="floatingInputCustom"
                                type="email"
                                required
                                placeholder="name@example.com"
                                value={email}
                                disabled={sending}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <label style={{marginLeft: '0.5rem'}} className='form-label' htmlFor="floatingInputCustom">Email</label>
                        </STC.Form.FloatingLabel>
                        
                        {showError && <div className='mt-2'>
                            <STC.Alert variant='danger'>
                                There was an error sending your password reset request. Please try again later.
                            </STC.Alert>
                        </div>}
                    <div className="mt-2" style={{display: "grid", gridTemplateColumns: "1fr 1fr"}}>
                        <div>
                            <STC.Button disabled={sending} size='sm' type="button" onClick={()=> setForgotPassword(false)}>Back</STC.Button>
                        </div>
                        <div align={'right'}>
                            <STC.Button size='sm' disabled={sending} className={'cmn-button login-button'} type={'submit'}>{sending ? 'Submitting': 'Submit'}</STC.Button>
                        </div>
                    </div>

                    </STC.Form>

                </div>
             }
            
        </div>
    )
}